import React, { useEffect } from "react";
import { Link } from "react-router-dom";
//
import dataPortofolioImg from "./dataPortfolioImg.json";

/*





*/
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
//
//
const Portfolio = () => {
  // USE EFFECT related to aos animation
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  const imageCardPorfolio = dataPortofolioImg;
  //
  return (
    <React.Fragment>
      <section id="portfolio">
        <div className="portfolio___wrapper">
          {/* ------- */}
          {/* HEADER  */}
          {/* ------- */}
          <div className="header__Portfolio">
            {" "}
            <h1>Portfolio</h1>
          </div>


      

          {/* ---------- */}
          {/*    MODAL   */}
          {/* ---------- */}
          <div id="galleryPortfolio___modal">
            <div className="portfolioImg__Wrapper">
              <div className="portfolioImg__container__grid">
                {imageCardPorfolio.map((itemImg) => (
                  <div className="portfolioImg_card" key={itemImg.id}>
                    <p>
                      {itemImg.text1} <span>{itemImg.text2} </span>
                    </p>{" "}
                    <div className="img_box_portfolio">
                      <Link to={itemImg.component}>
                        <motion.img
                          data-aos="fade-down"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(eImg) => {}}
                          onHoverEnd={(eImg) => {}}
                          src={itemImg.img1Portfolio}
                          alt={itemImg.alt}
                        />
                      </Link>
                    </div>
                  </div>
                ))}
                {/* ------------- */}
              </div>
            </div>
          </div>
       
        </div>
      </section>
    </React.Fragment>
  );
};

export default Portfolio;

/*






*/
